// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__nUy6M","row":"Node_row__21kNI","label":"Node_label__2BqD3","footer":"Node_footer__dwu3c"};